module.exports = __webpack_public_path__ + "assets/Icona_frutta_yogurtmenu_laterale.b50c1d66.svg";